export {default as H3HexagonLayerIcon} from './h3-hexagon-layer-icon';
export * from './h3-hexagon-layer';
